import React from "react";

import { useQuery } from "@apollo/client/react/hooks";

import { OrderByDirection } from "@/gql/graphql";
import { formatISODate } from "@/utils/datetime";

import { ClientList } from "./ClientList";
import { foodJournalingClientsQuery } from "../graphql/dashboardPageQueries";

export const FoodJournalingTab: React.FC = () => {
  const { data, loading, refetch } = useQuery(foodJournalingClientsQuery, {
    variables: {
      currentDate: formatISODate(new Date()),
      orderByName: OrderByDirection.Asc,
      statuses: ["active", "struggling", "inactive"],
    },
  });

  return (
    <ClientList
      isLoading={loading}
      tab="foodJournaling"
      clients={data?.foodJournalingClients.nodes ?? []}
      onSort={(sortBy) => refetch({ orderByName: sortBy })}
      onSearch={(searchKey) => refetch({ searchKey })}
      onFilterStatus={(statuses: string[]) => refetch({ statuses })}
    />
  );
};
